<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="领取单位">
              <a-input v-model="queryParam.danwei" placeholder="搜索领取单位"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="运动员姓名">
              <a-input v-model="queryParam.mname" placeholder="搜索运动员姓名"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="所属地区">
              <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="queryParam.namekeys" changeOnSelect
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="申报状态">
              <a-select v-model="queryParam.registstatus" placeholder="请选择"
                        allowClear>
                <a-select-option value="2">等待审核</a-select-option>
                <a-select-option value="1">审核成功</a-select-option>
                <a-select-option value="3">审核失败</a-select-option>
                <a-select-option value="4">预审核</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="学段">
              <a-select v-model="queryParam.xueduan" placeholder="请选择"
                        allowClear>
                <a-select-option value="幼儿园">幼儿园</a-select-option>
                <a-select-option value="小学">小学</a-select-option>
                <a-select-option value="初中">初中</a-select-option>
                <a-select-option value="高中">高中</a-select-option>
                <a-select-option value="大学">大学</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季赛区">
              <a-cascader :show-search="{ sjsqFilter }" :options="sjsqOptions"
                          :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区"
                          v-model="queryParam.sjsq" changeOnSelect/>
            </a-form-item>
          </a-col>


          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="联系人姓名">
                <a-input v-model="queryParam.name" placeholder="搜索负责人姓名"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="联系电话">
                <a-input v-model="queryParam.phone" placeholder="联系电话"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="申报时间">
                <a-range-picker
                    v-model="time_range_moment"
                    style="width: 100%"
                    format="YYYY-MM-DD HH:mm:ss"
                    :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons"
                  :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button @click="download(2)" style="margin-left: 8px">
        下载信息表
        <a-icon type="download" />
      </a-button>

      <a-upload
          name="file"
          accept=".xlsx"
          action
          :before-upload="beforeUpload"
          style="margin-left: 8px;display: inline-block"
      >
        <a-button key="upload"   >批量上传</a-button>
      </a-upload>


<a-button @click="downloadTpl()" style="margin-left: 8px">
        下载上传模版
        <a-icon type="download" />
      </a-button>

      <a-dropdown v-if="  selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <!--          <a-menu-item key="1"><a-icon type="delete" />删除</a-menu-item>-->
          <a-menu-item @click="onSihaoSetStatus(1)" key="2">审核通过</a-menu-item>
          <a-menu-item @click="onSihaoSetStatus(3)" key="3">审核失败</a-menu-item>
          <a-menu-item @click="onSihaoDeleteAll" key="1"><a-icon type="delete" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <s-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{ record.danwei }}
            <br/><span style="color: #999">{{ record.province }}{{ record.city }}{{ record.county }}</span>
            <br/>
            联系人:{{ record.name }} <span style="color: #999">手机:{{ record.phone }}</span>
            <br/>

            申请时间 {{ record.create_time|timeFormat }}

          </div>
      </span>
      <span slot="xiaozhang" slot-scope="text,record">
        校长 {{ record.xiaozhang_name }} ({{ record.xiaozhang_num }})<br/>
        教师 {{ record.jiaoshi_name }} ({{ record.jiaoshi_num }})
      </span>
      <span slot="jindu" slot-scope="text,record">

        <a-tag v-if="record.status==2" color="red">等待审核</a-tag>
        <a-tag v-else-if="record.status==1" color="green">审核成功</a-tag>
        <a-tag v-else-if="record.status==3" color="purple">审核失败</a-tag>
        <a-tag v-else>未提交</a-tag>
      </span>
      <span slot="action" slot-scope="text,record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteHandle(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>


    <a-modal
        :maskClosable="false"
        title="操作"
        :width="1200"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="visible"
        @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="省市"
                  hasFeedback
              >
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="formData.namekeys" changeOnSelect
                />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="领取单位"
                  hasFeedback
              >
                <a-input v-decorator="[
          'danwei',
          {rules: [{ required: true, message: '请输入领取单位' }]}
        ]"
                         placeholder="请输入领取单位"/>
              </a-form-item>
            </a-col>


          </a-row>


          <a-row :gutter="48">

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="年份"
              >
                <a-select v-decorator="[
              'year',
              {rules: [{ required: true, message: '请选择年份' }]}
              ]"
                          placeholder="请选择年份">
                  <a-select-option value="2023">2023</a-select-option>
                  <a-select-option value="2022">2022</a-select-option>
                  <a-select-option value="2021">2021</a-select-option>
                  <a-select-option value="2020">2020</a-select-option>
                  <a-select-option value="2019">2019</a-select-option>
                  <a-select-option value="2018">2018</a-select-option>
                  <a-select-option value="2017">2017</a-select-option>
                  <a-select-option value="2016">2016</a-select-option>
                  <a-select-option value="2015">2015</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系人姓名"
                  hasFeedback
              >
                <a-input v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入联系人姓名' } ]}
        ]"
                         placeholder="请输入联系人姓名"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="手机"
                  hasFeedback
              >
                <a-input type="number" v-decorator="[
          'phone',
          {rules: [{ required: true, message: '请输入联系人手机' }]}
        ]"
                         placeholder="请输入联系人手机"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  hasFeedback
                  label="领取时间">
                <a-date-picker
                    style="width: 100%"
                    v-model="formData.getdate_moment"
                    format="YYYY-MM-DD"  />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  label="赛区"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
              >
              {{formData.getaddress}}

              <a-select showSearch
                    optionFilterProp="name" style="width:800px" v-model="formData.stationid" placeholder="请选择"
                        allowClear >
                <a-select-option :key="index" v-for="(option,index) in saiquOptions" :value="option.id" :name="option.name">{{option.name}}</a-select-option>
              </a-select>

              </a-form-item>
            </a-col> 
          </a-row>

<!--          <a-divider>校长信息</a-divider>-->
<!--          <a-row :gutter="48">-->
<!--            <a-col :md="12" :sm="24">-->
<!--              <a-form-item-->
<!--                  :labelCol="labelCol"-->
<!--                  :wrapperCol="wrapperCol"-->
<!--                  label="校长姓名"-->
<!--                  hasFeedback-->
<!--              >-->
<!--                <a-input v-decorator="[-->
<!--          'xiaozhang_name',-->
<!--          {rules: [{ required: true, message: '请输入校长姓名' }]}-->
<!--        ]"-->
<!--                         placeholder="请输入负责人姓名"/>-->
<!--              </a-form-item>-->

<!--            </a-col>-->
<!--            <a-col :md="12" :sm="24">-->
<!--              <a-form-item-->
<!--                  :labelCol="labelCol"-->
<!--                  :wrapperCol="wrapperCol"-->
<!--                  label="校长身份证号"-->
<!--                  hasFeedback-->
<!--              >-->
<!--                <a-input v-decorator="[-->
<!--          'xiaozhang_num',-->
<!--          {rules: [{ required: true, message: '请输入校长身份证号' }]}-->
<!--        ]"-->
<!--                         placeholder="校长身份证号"/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--          </a-row>-->


<!--          <a-divider>教师信息(先进个人)</a-divider>-->
<!--          <a-row :gutter="48">-->
<!--            <a-col :md="12" :sm="24">-->
<!--              <a-form-item-->
<!--                  :labelCol="labelCol"-->
<!--                  :wrapperCol="wrapperCol"-->
<!--                  label="教师姓名"-->
<!--                  hasFeedback-->
<!--              >-->
<!--                <a-input v-decorator="[-->
<!--          'jiaoshi_name',-->
<!--          {rules: [{ required: true, message: '请输入教师姓名' }]}-->
<!--        ]"-->
<!--                         placeholder="请输入教师姓名"/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="12" :sm="24">-->
<!--              <a-form-item-->
<!--                  :labelCol="labelCol"-->
<!--                  :wrapperCol="wrapperCol"-->
<!--                  label="教师身份证"-->
<!--                  hasFeedback-->
<!--              >-->
<!--                <a-input v-decorator="[-->
<!--          'jiaoshi_num',-->
<!--          {rules: [{ required: true, message: '请输入教师身份证' }]}-->
<!--        ]"-->
<!--                         placeholder="请输入教师身份证"/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--          </a-row>-->

          <a-divider>人员信息</a-divider>
          <a-table :columns="subjectColumns" :data-source="formData.member_list" :pagination="false">
            <p slot="extra_field" slot-scope="record" style="margin: 0">
            </p>
            <p slot="name" slot-scope="text,record">
              {{ record.name }} ({{ record.mingzu }})
              <br/>
              {{ record.num }} 
            </p>
            <p slot="defen" slot-scope="text,record">
              品德得分:{{ record.score_pingde }}<br/>
              学段得分:{{ record.score_xuexi }}<br/>
              气质得分:{{ record.score_qizhi }}<br/>
              技术得分:{{ record.score_jishu }}<br/>
              投票得分:{{ record.score_toupiao }}<br/>
            </p>
            <!-- <template slot="action" slot-scope="text,record,index">
              <a href="javascript:;" @click="onEditUser(record)">编辑</a>
              <a-divider type="vertical"/>
            </template> -->
          </a-table>

          <a-divider>审核信息</a-divider>

          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
              <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="备案审核"
                  hasFeedback
              >
                <a-radio-group v-model="formData.status" buttonStyle="solid">
                  <a-radio-button :value="0">未提交</a-radio-button>
                  <a-radio-button :value="2">待审核</a-radio-button>
                  <a-radio-button :value="1">审核通过</a-radio-button>
                  <a-radio-button :value="3">审核失败</a-radio-button>
<!--                  <a-radio-button :value="4">待支付</a-radio-button>-->
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
              <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="管理员备注"
                  hasFeedback
              >
                <a-textarea autosize v-decorator="[
          'adminnote',
          {rules: []}
        ]"
                            placeholder="管理员备注"/>
              </a-form-item>
            </a-col>
          </a-row>


        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>
  </a-card>
</template>

<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import RSwitch from '@/components/RSwitch/'
import PicUploader from '@/components/PicUploader/'
import FileUploader from '@/components/FileUploader/'
import areaOptions from '@/utils/area'
import{saiquOptions} from '@api/sai'
import moment from 'moment'
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
  import XLSX from "xlsx";
import { 
  sjsqOptions, 
} from '@/api/sai'


import {getSihaoList, getSihaoDetail, editSihao, deleteSihao,sihaoStatusAll, sihaoDeleteAll,getSihaoDownloadUrl,sihaoImport} from '@/api/sihao'

export default {
  name: 'SihaoList',
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    STable,
    RSwitch,
    EditableCell,
  },
  data() {
    return {
      areaOptions,
      dateFormat: 'YYYY/MM/DD',
      visible: false,
      saveLoading: false,
      sjsqOptions: [],
      formData: {
        id: 0,
        danwei: '',
        changdipic: [],
        namekeys: [],
        saiquOptions:[],
        areas: [],
        member_list: [],
        getdate: '',
        getdate_moment: null,
        is_tequan: 2,
      },
      buyGoodsOptions: [
        {
          "label": "1 标准肋木",
          "value": 1
        },
        {
          "label": "2 标准把杆（固定/移动）",
          "value": 2
        },
        {
          "label": "3 斜坡啦啦操垫（翻滚）",
          "value": 4
        },
        {
          "label": "4 啦啦操训练垫",
          "value": 8
        },
        {
          "label": "5 柔韧测试器（髋部）",
          "value": 16
        },
        {
          "label": "6 积木式跳箱",
          "value": 32
        },
        {
          "label": "7 柔韧测试器（肩部）",
          "value": 64
        },
        {
          "label": "8 啦啦操翻腾训练辅助器（组合）A",
          "value": 128
        },
        {
          "label": "9 啦啦操翻腾训练辅助器（组合）B",
          "value": 256
        },
        {
          "label": "10 七彩星级专用训练考试地胶",
          "value": 512
        },
        {
          "label": "11 啦啦操方形蹦床",
          "value": 1024
        },
        {
          "label": "12啦啦操专用平衡器",
          "value": 2048
        }
      ],
      time_range_moment: [],
      time_range: [],
      labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
        xs: {span: 24},
        sm: {span: 8},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 12},
      },
      form: this.$form.createForm(this),
      mdl: {},
      getDateString: '',

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: '',
        sjsq:[],
      },
      // 表头
      subjectColumns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '姓名',
          dataIndex: 'name',
          scopedSlots: {customRender: 'name'},
        },
        {
          title: '学段',
          dataIndex: 'xueduan',
        }, 
        {
          title: '得分',
          dataIndex: 'defen',
          scopedSlots: {customRender: 'defen'},
        }, 
      ],
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '单位信息',
          dataIndex: 'danwei',
          scopedSlots: {customRender: 'danwei'},
        },
        // {
        //   title: '授权编号',
        //   dataIndex: 'xiaozhang_name',
        //   scopedSlots: {customRender: 'xiaozhang'},
        // },
        {
          title: '进度',
          dataIndex: 'jindu',
          scopedSlots: {customRender: 'jindu'},
        },
        {
          title: '操作',
          dataIndex: 'action',
          // fixed: 'right',
          width: 120,
          scopedSlots: {customRender: 'action'},
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData');
        console.log(this.queryParam);
        let that = this;

        if (this.time_range_moment[0] && this.time_range_moment[1]) {
          this.queryParam.time_range = [
            this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
            this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
          ]
        } else {
          this.queryParam.time_range = []
        }

        this.queryParam = Object.assign(this.queryParam, parameter);
        return getSihaoList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
      },

      selectedRowKeys: [],
      selectedRows: [],
      cashFormData: {
        ids: [],
        to_type: '',
        price: 0,
        note: '',
        count: 0,
      }
    }
  },
  computed: {},
  created() {
  },

  mounted() {
    let that = this;
      that.getSjsqOptions();
  },
  methods: {
    moment,
      getSjsqOptions() {
        let that = this;
        sjsqOptions({}).then(res => {
          that.sjsqOptions = res.data;
        });
        saiquOptions({ 
        }).then(res =>{
          that.saiquOptions = res.data;
        });
      },
    handleCancel() {
      this.visible = false
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleEdit(record) {
      let self = this
      this.visible = true
      getSihaoDetail({id: record.id}).then(res => {
        setTimeout(() => {
          self.form.setFieldsValue({...res.data})
          self.formData.id = record.id;
          if (res.data.namekey) {
            res.data.namekeys = [res.data.namekey.substring(0, 2) + '0000', res.data.namekey.substring(0, 4) + '00', res.data.namekey];
          } else {
            res.data.namekeys = []
          }
          res.data.getdate_moment = moment(res.data.getdate,'YYYY-MM-DD');
          self.formData = {...res.data};

          console.log('handleEdit', self.formData)

        }, 20)
      })
      // console.log(this.mdl)
    },

    deleteHandle(record) {
      let self = this
      deleteSihao({ id: record.id }).then(res => {
        self.$message.success('删除成功')
        self.$refs.table.refresh(false)
      }).catch(err =>{
        self.$message.error(err.data.msg)
      })
    },

    onSihaoDeleteAll() {
      let self = this
      sihaoDeleteAll({ ids: this.selectedRowKeys }).then(res => {
        self.$message.success('删除成功')
        self.$refs.table.refresh(false)
      }).catch(err =>{
        self.$message.error(err.data.msg)
      })
    },

    onSihaoSetStatus(status) {
      let self = this
      sihaoStatusAll({ ids: this.selectedRowKeys,status }).then(res => {
        self.$message.success('设置成功')
        self.$refs.table.refresh(false)
      }).catch(err =>{
        self.$message.error(err.data.msg)
      })
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

    onDateChange(date, dateString) {
      console.log(date, dateString);
      this.formData.getdate = dateString
    },

    // 增改 处理
    handleOk(e) {
      let self = this;
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
          self.saveLoading = true;
          editSihao({
            id: self.formData.id,
            namekey: self.formData.namekeys[self.formData.namekeys.length - 1],
            danwei: values.danwei,
            renshu: values.renshu,
            name: values.name,
            phone: values.phone,
            year: values.year,
            getdate:self.formData.getdate_moment.format('YYYY-MM-DD'),

            status: self.formData.status,
            stationid: self.formData.stationid,
            getaddress: self.formData.getaddress,
            status: self.formData.status,
            adminnote: values.adminnote,
          }).then(res => {
            self.$message.success('修改成功')
            self.$refs.table.refresh(false)
            self.visible = false;
            self.saveLoading = false;
          }).catch(err => {
            self.$message.error(err.data.msg);
            self.saveLoading = false;
          })
        }
      })
    },

    download(type){
      let params = Object.assign(this.queryParam, { time_range: this.time_range_moment, type: type })
      // console.log('params', params);return
      getSihaoDownloadUrl(params)
          .then(res => {
            console.log(res)
            window.open(res.data)
          })
          .catch(err => {
            this.$message.error(err.data.msg)
          })
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },




    beforeUpload(file) {
      let that = this;
      let formdata = new FormData();
      console.log(file);
      formdata.append("upfile", file);
      formdata.append("action", "test");
      console.log("formdata", formdata); 
      let userList = [];
      if(this.queryParam.sjsq.length<2){
        that.$message.error('请先选择赛季赛区');
        return;
      }

      this.file2Xce(file).then((tabJson) => {
        // console.log('this.xlsxJson', tabJson);
        if (tabJson && tabJson.length > 0) {
          this.xlsxJson = tabJson
          console.log("this.xlsxJson", tabJson);
          // return ;
          if (typeof tabJson[0].sheet[0].__EMPTY_12 == 'undefined' || tabJson[0].sheet[0].__EMPTY_12 != "版本202301") {
            // that.$message.error('文件版本不正确');
            // return;
          }

          // return ;

          tabJson[0].sheet.map((item, index) => {
            if (index >= 0 && item["身份证号"]) {

                userList.push({
                  year: item["申报时间"],
                  namekey: item["省市代码"],
                  getaddress: item["领取比赛或活动名称"],
                  getdate: getFormatDate_XLSX(item["领取日期"]),
                  danwei: item["领取单位"],
                  danweiname: item["联系人"],
                  phone: item["电话"],
                  name: item["运动员姓名"],
                  num: item["身份证号"],
                  mingzu: item["民族"] || "",
                  xueduan: item["学段"] || "",
                  score_pingde: item["品德得分"] || "", 			
                  score_xuexi: item["学段得分"] || "", 
                  score_qizhi: item["气质得分"] || "", 
                  score_jishu: item["技术得分"] || "",  
                  score_toupiao: item["投票得分"] || "",   
                });

            }
          });

          // return ;
          console.log('userList', userList);
          // return
          ;
      
          sihaoImport({ 
            sjsq:that.queryParam.sjsq,
            list:JSON.stringify(userList)
          })
            .then(res => {
              that.$message.success('上传成功') 
              that.$refs.table.refresh(true)
            })
            .catch(err => {
              that.$message.error(err.data.msg)
            })


        }
      });

      return false; // false就是不自动上传，我后来试了发现都一样，都不会自动上传
    },

    file2Xce(file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader();
        reader.onload = function (e) {
          const data = e.target.result;
          this.wb = XLSX.read(data, {
            type: "binary",
          });
          const result = [];
          this.wb.SheetNames.forEach((sheetName) => {
            result.push({
              sheetName: sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName]),
            });
          });
          resolve(result);
        };
        // reader.readAsBinaryString(file.raw)
        reader.readAsBinaryString(file); // 传统input方法
      });
    },
      sjsqFilter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },

    downloadTpl(){
      window.open('https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1694934981169-3/%E5%9B%9B%E5%A5%BD%E8%BF%90%E5%8A%A8%E5%91%98%E7%94%B3%E8%AF%B7%E8%A1%A82023.xlsx.xlsx')
    },


  },
  filters: {
    jinduFilter(value) {
      switch (value) {
        case 1:
          return `联系申报单位`;
        case 2:
          return `告知省级并征求意见+申报单位积极准备中`;
        case 3:
          return `申报单位积极准备中`;
        case 4:
          return `条件已具备，等待验收`;
        case 5:
          return `等待全国啦啦操验收`;
        case 6:
          return `验收并授牌`;
        case 7:
          return `同意考试`;
      }
    },
  },
  watch: {}
}
</script>
